import Header from '../../components/Layout/Header';
import TrackDatManual from '../../components/TrackDatManual/TrackDatManual';
import { getTrackDatManualProps } from '../../lib/trackdatManual';
import styles from './TrackDat.module.css';

export function getStaticProps() {
  return { props: getTrackDatManualProps() };
}

function TrackDatManualPage(props) {
  return <TrackDatManual {...props} productRoute="/TrackDat" />;
}

TrackDatManualPage.getLayout = function getLayout(page) {
  return (
    <>
      <Header variant="trackdat" productHref="/TrackDat" />
      <div className={styles.trackDatChromeOffset}>{page}</div>
    </>
  );
};

export default TrackDatManualPage;

